import Vue from "vue";
import Vuetify from "vuetify/lib";

Vue.use(Vuetify);

export default new Vuetify({
  theme: {
    themes: {
      light: {
        primary: "#23409a",
        secondary: "#ffeb3b",
        accent: "#23409a",
        error: "#b71c1c",
      },
    },
  },
});
